import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';

type Toast = {
    type: 'success' | 'error';
    message: string;
    ms: number;
}

type AddToast = Omit<Toast, 'ms'> & {
    ms?: number;
}

type State = {
    toast: Toast | null;
    showToast: (toast: AddToast) => void;
};

type Props = {
    children: React.ReactNode;
};

const ToastContext = createContext<State>({} as State);

const ToastProvider: React.FC<Props> = ({ children }) => {
    const [toast, setToast] = useState<Toast | null>(null);

    useEffect(() => {
        if (toast) {
            const timeout = setTimeout(() => setToast(() => null), toast.ms);

            return () => clearTimeout(timeout);
        }
    }, [toast])

    const showToast = useCallback((toast: AddToast) => {
        let ms: number | undefined = toast.ms;

        if (!ms)
            ms = toast.type === 'success' ? 3000 : 5000;

        setToast({
            ...toast,
            ms
        });
    }, []);

    return (
        <ToastContext.Provider
            value={{
                toast,
                showToast
            }}
        >
            {children}
        </ToastContext.Provider>
    );
};

const useToast = (): State => {
    const context = useContext(ToastContext);

    return context;
}

export { ToastProvider, useToast };